<template>
  <div id="play"></div>
</template>
<script  type="text/ecmascript-6">
// import Player from "xgplayer";
import "xgplayer";
import FlvPlayer from "xgplayer-flv";

export default {
  data() {
    return {};
  },
  mounted() {
    new FlvPlayer({
      el: document.querySelector("#play"),
      url: "http://video.jacking.cn/live/task99999999999999999.flv?txSecret=2155dc1408a0a3540ce9396297afb648&txTime=60F1AD00",
      autoplay: false,
      isLive: true,
      playsinline: true,
      width: 700,
      height: 400,
      cors: true,
      // playbackRate: [0.5, 0.75, 1, 1.5, 2], //传入倍速可选数组
    });
  },
  methods: {},
};
</script>